import List from '../views/imports/list'

export default [
    {
        path: '/admin/imports',
        name: 'source-imports',
        component: List,
        meta: {
            permission: 'can_import_sources',
        },
    }
]
